import thunk from "redux-thunk";
import { createStore, applyMiddleware, combineReducers } from "redux";
import userReducer from "../reducers/userReducer";
import uploadFileReducer from "../reducers/uploadFileReducer";
import getActiveOrderReducer from "../reducers/getActiveOrderReducer";
import getAllOrderReducer from "../reducers/getAllOrderReducer";


const initialState = {};
const reducers = combineReducers({
  userReducer: userReducer,
  uploadFileReducer:uploadFileReducer,
  getActiveOrderReducer:getActiveOrderReducer,
  getAllOrderReducer:getAllOrderReducer


});
const middleware = [thunk];

const store = createStore(
  reducers,
  initialState,
  applyMiddleware(...middleware)
);
export default store;
